import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import userClient from 'packages/smart-home-support/api/userClient';
import { DeviceIcon, LoadingOverlay } from 'packages/smart-home-support/components';
import { useCancelableEffect, useQueryParam } from 'packages/smart-home-support/hooks';
import { UserContext } from '../../../auth/UserProvider';
import { TechCoachCTA } from '../../components';
import { Device } from '../../models';
import { Button, PageContainer, Heading2 } from '../../styles';
import { useDevices } from '../../hooks';
import { getBreakpoint, getTabUrl } from '../../utils';
import { LinkId } from 'packages/smart-home-support/constants';

const breakpoint = getBreakpoint();

const s = {
  PageContainer: styled(PageContainer)`
    @media ${breakpoint} {
      display: flex;
      margin-top: 50px;
    }
  `,
  TechCoachCTAWrapper: styled.div`
    @media ${breakpoint} {
      width: 50%;
    }
  `,
  Heading2: styled(Heading2)`
    text-align: center;
    margin-top: 10px;
  `,
  ActionContainer: styled.div`
    margin-top: 20px;
  `,
  DeviceWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
    @media ${breakpoint} {
      width: 50%;
    }
  `,
  DeviceIconWrapper: styled.div`
    width: 87px;
    height: 87px;
  `,
};

const ViewDevicePage = () => {
  const { user, setDevices } = useContext(UserContext);
  const [deviceId] = useQueryParam('deviceId');
  const [devices] = useDevices(user);
  const [device, setDevice] = useState<Device>();
  const [isLoading, setIsLoading] = useState(false);
  const [deleteComplete, setDeleteComplete] = useState(false);

  useCancelableEffect(() => {
    if (devices && deviceId) {
      setDevice(devices.find(({ id }) => deviceId === id));
    }
  }, [devices, deviceId]);

  const onDeleteClick = async () => {
    if (devices && device && user) {
      setIsLoading(true);
      const newDevices = await userClient.deleteDevice(devices, device.id);
      setDevices(newDevices);
      setDeleteComplete(true);
    }
  };

  return deleteComplete ? (
    <Redirect to={`${getTabUrl('devices')}&deviceRemoved=1`} />
  ) : (
    <s.PageContainer>
      <LoadingOverlay in={isLoading || !devices} isFullPage />
      <s.DeviceWrapper>
        <s.DeviceIconWrapper>{device && <DeviceIcon deviceType={device.type} isAccented />}</s.DeviceIconWrapper>
        <s.Heading2>{device ? device.label : <>&nbsp;</>}</s.Heading2>
        <s.ActionContainer>
          <Button inverted className="view-device-delete-device" onClick={() => onDeleteClick()}>
            Remove device
          </Button>
        </s.ActionContainer>
      </s.DeviceWrapper>
      <s.TechCoachCTAWrapper>
        <TechCoachCTA chatLinkId={LinkId.DashboardDeviceViewChat} callLinkId={LinkId.DashboardDeviceViewCall} />
      </s.TechCoachCTAWrapper>
    </s.PageContainer>
  );
};

export default ViewDevicePage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/ViewDevicePage/ViewDevicePage.tsx